import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchAllocations,
  fetchAllocationStatistics,
  initialFilters
} from 'ducks/allocations';
import {withFilters, FILTERS} from 'components/withFilters';

import {UndoArchiveRoomForm, Buttons} from './components';

class UndoArchiveRoomModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('undoArchiveRoom');

  getExtraActions = () => {
    const {locationRef} = this.props.data;
    return [
      () => this.props.clearFilters(),
      () => fetchAllocations({locationRef}),
      () => fetchAllocationStatistics({locationRef}),
      ...this.props.closeModalExtraActions
    ];
  };

  render() {
    const {closeModal, form: {submitting}, data: {locationRef}} = this.props;
    return (
      <Modal
        modalOverlayClassName="UndoArchiveRoomModalOverlay"
        className="UndoArchiveRoomModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Undo Archive Room" />
        <Modal.Body>
          <UndoArchiveRoomForm
            storeDataExtraActions={this.props.storeDataExtraActions}
            getExtraActions={this.getExtraActions}
            locationRef={locationRef}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            closeModal={closeModal}
            triggerSubmit={this.triggerSubmit}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('undoArchiveRoom')(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withFilters(
    withModal(MODALS.UNDO_ARCHIVE_ROOM)(UndoArchiveRoomModal),
    FILTERS.ALLOCATIONS_CALENDAR,
    {initialFilters, clearFiltersOnUnmount: false}
  )
);
